import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import AIAnalysisToast from "@/components/AIAnalysisToast";
import TriggerNotification from "@/components/TriggerNotification";
import { JournalFilterProvider } from "./contexts/JournalFilterContext";
import { TimezoneProvider } from "./contexts/TimezoneContext";
import { SidebarCollapseProvider } from "./hooks/useSidebarCollapse";
import { useTagColorSync } from "./hooks/useTagColorSync";
import { useUserLocale } from "./hooks/useUserLocale";
import { useUserTheme } from "./hooks/useUserTheme";
import { WatchlistSidebarCollapseProvider } from "./hooks/useWatchlistSidebarCollapse";
import { cleanupExpiredOAuthState } from "./utils/oauth";
import { migrateStorageKeys } from "./utils/storage";

const App = () => {
  // Apply user preferences reactively
  useUserLocale();
  useUserTheme();

  // Sync tag colors from API to global cache
  // This ensures TagNode (editor) and LexicalContent (memos) always show current colors
  useTagColorSync();

  // Clean up expired OAuth states on app initialization
  // Migrate localStorage keys from legacy "memo" to "journal" naming
  useEffect(() => {
    cleanupExpiredOAuthState();
    migrateStorageKeys();
  }, []);

  return (
    <TimezoneProvider>
      <SidebarCollapseProvider>
        <WatchlistSidebarCollapseProvider>
          <JournalFilterProvider>
            <Outlet />
            <AIAnalysisToast />
            <TriggerNotification />
          </JournalFilterProvider>
        </WatchlistSidebarCollapseProvider>
      </SidebarCollapseProvider>
    </TimezoneProvider>
  );
};

export default App;
